import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';
import { PHASE } from './constants';
import { monitoring } from './monitoring';

/** 通常停止処理 */
export async function stop(self) {
  try {
    self.isLoading = true;

    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'stop'
      },
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      (errorType) => { errorType; self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      (result) => { self.validateErrorResult(result); },
    );

    if (response) {
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          // 正常終了：停止監視処理へ遷移
          await monitoring(self, self.phase);
          break;
        case REQUEST_STATUS_FAILED:
          // 異常終了：通信エラー(処理継続)へ遷移
          self.phase = PHASE.COMMUNICATION_ERROR;
          return;
      }
    }
  } finally {
    self.isLoading = false;
  }
}

